const NS = 'MarketCurrencyMovementsTableBlock';
const CLS = 'marketCurrencyMovementsTableBlock';

import { TableBlock } from '../../tableBlock/js/tableBlock';

export class MarketCurrencyMovementsTableBlock extends TableBlock {
	constructor(element) {
		super(element, CLS);

		this.api = this.$element.attr('data-api');

		this.getTableDataFromApi();
	}

	setTableData() {
		this.columnDefs = [
			{
				headerName: 'Key',
				field: 'key',
				cellStyle: {
					'font-weight': 500
				},
				minWidth: 145,
				lockPosition: true
			},
			{
				headerName: 'Value',
				field: 'value',
				cellRenderer: this.marketCurrencyMovementsCellRenderer,
				minWidth: 145,
				lockPosition: true
			}
		];
	}

	setGridOptions() {
		super.setGridOptions({
			headerHeight: 0
		});
	}

	marketCurrencyMovementsCellRenderer(params) {
		let markup = '';

		let innerValue = !_.isNil(params.value) && !_.isNil(params.value.value) ? params.value.value : null;
		let valueDisplayText = !_.isNil(params.value) && !_.isNil(params.value.valueDisplayText) ? params.value.valueDisplayText : null;
		let difference = !_.isNil(params.value) && !_.isNil(params.value.difference) ? params.value.difference : null;
		let differenceDisplayText = !_.isNil(params.value) && !_.isNil(params.value.differenceDisplayText) ? params.value.differenceDisplayText : null;

		let formattedDifference = (value) => {
			if(!_.isNil(value)) {
				if(value < 0) {
					return `<span class="cell-difference text-red">${differenceDisplayText}</span>`;
				}
				else if(value > 0) {
					return `<span class="cell-difference text-green">${differenceDisplayText}</span>`;
				}
			}
			return '<span class="cell-difference"></span>';
		};

		// value is an object that contains the values that we are going to render
		if(innerValue && difference && valueDisplayText && differenceDisplayText) {
			markup = `
				<span class="cell-container">
					<span class="cell-value">${innerValue}</span>
					${formattedDifference(difference)}	
				</span>
			`;
		}
		else {
			markup = `
				<span class="cell-container">
					<span class="cell-value">-</span>
				</span>
			`;
		}
		return markup;
	}

	getTableDataFromApi() {
		let url = this.api;

		if(!_.isEmpty(this.urlParams)) {
			url += `?${$.param(this.urlParams)}`;
		}

		if(this.api) {
			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: (response) => {
					if(response && response.length > 0) {
						this.$element.trigger(`${CLS}.update`, {
							data: response
						});
					}
					else {
						this.$element.trigger(`${CLS}.update`, {
							data: null,
							isEmpty: true
						});
					}
				},
				error: () => {
					this.$element.trigger(`${CLS}.update`, {
						data: null,
						isError: true
					});
				}
			});
		}
		else {
			console.error(`${NS}::Error`, 'API is not set.');
			this.$element.trigger(`${CLS}.update`, {
				data: null
			});
		}
	}
}
